export const SUBSCRIPTION = "subscription";

export const RENEW = "renew";

export const ADDON = "addon";
